import { useInView } from '../../hooks/useInView';

interface MidCTAProps {
  headline?: string;
  subheadline?: string;
  cta1?: { text: string; href: string };
  cta2?: { text: string; href: string };
}

export default function SectionMidCTA({
  headline = 'Ready to Begin?',
  subheadline = 'Speak with a dive specialist. No obligation — we\'ll match you with the right program.',
  cta1 = { text: 'Start Your Diving Journey', href: '#contact' },
  cta2 = { text: '+1 786-241-3194', href: 'tel:+17862413194' },
}: MidCTAProps) {
  const { ref, inView } = useInView();

  return (
    <section className="bg-[#00B4D8] relative overflow-hidden py-16 md:py-20">
      {/* Subtle inner texture */}
      <div className="absolute inset-0 opacity-10" style={{ background: 'radial-gradient(ellipse 80% 100% at 50% 0%, rgba(255,255,255,0.3) 0%, transparent 70%)' }} />
      <div className="absolute top-0 right-0 w-96 h-full bg-white/5 skew-x-12 transform translate-x-24 pointer-events-none" />

      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={`relative z-10 max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-8 transition-all duration-700 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {/* Text */}
        <div>
          <h3
            className="text-3xl md:text-4xl font-black text-white leading-tight mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {headline}
          </h3>
          <p className="text-white/75 text-[15px] max-w-lg">{subheadline}</p>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <a
            href={cta1.href}
            className="inline-flex items-center justify-center gap-2.5 bg-white text-[#00B4D8] hover:bg-[#E8F8FC] font-bold px-9 rounded-full transition-all duration-300 hover:-translate-y-0.5 text-[15px] whitespace-nowrap cursor-pointer"
            style={{ paddingTop: '16px', paddingBottom: '16px' }}
          >
            {cta1.text}
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href={cta2.href}
            className="inline-flex items-center justify-center gap-2.5 border-2 border-white/40 hover:border-white text-white font-bold px-9 rounded-full transition-all duration-300 text-[15px] whitespace-nowrap cursor-pointer"
            style={{ paddingTop: '16px', paddingBottom: '16px' }}
          >
            <i className="ri-phone-line" />
            {cta2.text}
          </a>
        </div>
      </div>
    </section>
  );
}
